// extracted by mini-css-extract-plugin
export default {"costSectionRow":"CostSection_costSectionRow__e3XxP","statsCol":"CostSection_statsCol__kKGIK","graphCol":"CostSection_graphCol__4WWMt"};